import {ApexOptions} from "apexcharts";

export type RowType = 'problems' | 'warnings' | 'recommendations'
export const UglyYellow = '#E0BF00'

export const reversedBarOptions = (chartData) : ApexOptions => ({
    series: [{
        data: chartData.map(item => item.value)
    }],
    chart: {
        type: 'bar',
        height: 350
    },
    plotOptions: {
        bar: {
            horizontal: true,
            distributed: true,
            dataLabels: {
                position: 'bottom'
            },
        }
    },
    colors: chartData.map(item => item.color),
    dataLabels: {
        enabled: true,
        textAnchor: 'start',
        style: {
            colors: ['#fff']
        },
        /*formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
        },*/
        offsetX: 0,
        dropShadow: {
            enabled: true
        }
    },
    xaxis: {
        categories: chartData.map(item => item.name),
    },
    grid: {
        xaxis: {
            lines: {
                show: true
            }
        }
    },
    yaxis: {
        reversed: true,
        axisTicks: {
            show: true
        },
        labels: {
            show: false
        }
    },
    tooltip: {
        theme: 'dark',
        custom: ({series, seriesIndex, dataPointIndex, w}) => {
            return `<div class="tooltip" style="background: none; padding: 10px">${w.globals.labels[dataPointIndex]}</div>`
        },
        x: {
            show: false
        },
        y: {
            title: {
                formatter: function () {
                    return ''
                }
            }
        }
    }
})